import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getFormValues } from "redux-form";

import Content from "../common/template/content";
import ContentCard from "../common/template/contentCard";
import ContentCardHeader from "../common/template/contentCardHeader";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import NewTr from "../common/table/newTr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import Button from "../common/button/button";
import Form from "./empresaForm";
import { setModoTela, initForm, salvar, excluir, getLista } from "./empresaActions";
import { Loading } from "../common/loading/loading";
import { useEffect } from "react";

function Empresa(props) {
    if (!props.usuarioLogado || props.usuarioLogado.acesso_cliente) {
        return <div />;
    }
    useEffect(() => {
        props.getLista();
    }, []);

    return (
        <div>
            {props.aguardando ? <Loading /> : null}

            <Content>
                {props.modoTela === "visualizacao" ? <Form visualizar onSubmit={() => {}} /> : null}
                {props.modoTela === "cadastro" ? <Form onSubmit={props.salvar} /> : null}
                {props.modoTela === "exclusao" ? <Form excluir onSubmit={props.excluir} /> : null}
                {props.modoTela === "lista" ? lista() : null}
            </Content>
        </div>
    );

    function lista() {
        return (
            <ContentCard>
                <ContentCardHeader>
                    <Row>
                        <Grid cols="12 6 4 2">
                            <Button
                                text="Adicionar"
                                type={"success"}
                                icon={"fa fa-plus"}
                                disabled={!props.usuarioLogado.administrador || props.usuarioLogado.id_empresa || props.usuarioLogado.id_cliente}
                                event={() => {
                                    const formularioPadrao = {
                                        acesso_modulo_dashboard: true,
                                        acesso_modulo_usuario: true,
                                        acesso_modulo_cliente: true,
                                        acesso_modulo_concessionaria: true,
                                        acesso_modulo_plataforma_mercado_livre: true,
                                        acesso_modulo_empenho: true,
                                        acesso_modulo_documento: true,
                                        acesso_modulo_demanda_contrato: true,
                                        acesso_modulo_contrato_mercado_livre: true,
                                        acesso_modulo_contrato_aluguel: true,
                                        acesso_modulo_geracao: true,
                                        acesso_modulo_geracao_integracao: true,
                                        acesso_modulo_consumo_integracao: true,
                                        acesso_modulo_rede: true,
                                        acesso_modulo_tributacao: true,
                                        acesso_modulo_fatura: true,
                                        acesso_modulo_gestao_tarefa: true,
                                        acesso_modulo_documento_adm: true,
                                        acesso_modulo_fatura_cliente: true,
                                        acesso_modulo_fatura_engenharia: true,
                                        acesso_modulo_verificador_icms_energia: true,
                                        acesso_modulo_verificador_consumo_agua: true,
                                        acesso_modulo_fatura_relatorio: true,
                                        acesso_modulo_analise: true,
                                        acesso_modulo_gestao_credito_solar: true,
                                        acesso_modulo_diagnostico_energia: true,
                                        acesso_modulo_redes_eletricas: true,
                                        acesso_modulo_documento_cliente: true,
                                        acesso_modulo_geracao_leitura: true,
                                        acesso_modulo_monitoramento_consumo: true,
                                    };
                                    props.setModoTela("cadastro", { ...formularioPadrao });
                                    props.initForm({ ...formularioPadrao });
                                }}
                            />
                        </Grid>
                    </Row>
                </ContentCardHeader>
                <ContentCardBody>
                    <Table responsive>
                        <THead>
                            <NewTr backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#F5F5F5"}>
                                <Th sticky>Nome</Th>
                                <Th sticky>CNPJ</Th>
                            </NewTr>
                        </THead>
                        <TBody>
                            {props.lista.map((item) => {
                                const registro = { ...item };
                                return (
                                    <NewTr
                                        key={item.id}
                                        backgroundColorTr={"#FFFFFF"}
                                        backgroundColorTd={"#F5F5F5"}
                                        botoes={[
                                            {
                                                type: "primary",
                                                icon: "fas fa-eye",
                                                disabled: !props.usuarioLogado.administrador || props.usuarioLogado.id_empresa || props.usuarioLogado.id_cliente,
                                                event: () => {
                                                    props.setModoTela("visualizacao", registro);
                                                    props.initForm(registro);
                                                },
                                            },
                                            {
                                                type: "warning",
                                                icon: "fas fa-pencil-alt",
                                                disabled: !props.usuarioLogado.administrador || props.usuarioLogado.id_empresa || props.usuarioLogado.id_cliente,
                                                event: () => {
                                                    props.setModoTela("cadastro", registro);
                                                    props.initForm(registro);
                                                },
                                            },
                                            {
                                                type: "danger",
                                                icon: "fas fa-trash-alt",
                                                disabled: !props.usuarioLogado.administrador || props.usuarioLogado.id_empresa || props.usuarioLogado.id_cliente,
                                                event: () => {
                                                    props.setModoTela("exclusao", registro);
                                                    props.initForm(registro);
                                                },
                                            },
                                        ]}
                                    >
                                        <Td>{item.nome}</Td>
                                        <Td>{item.cnpj ? item.cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : " - "}</Td>
                                    </NewTr>
                                );
                            })}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    }
}

const mapStateToProps = (state) => ({
    sessao: state.auth.usuario,
    usuarioLogado: state.auth.usuarioLogado,
    modoTela: state.empresa.modoTela,
    formularioValues: getFormValues("empresaForm")(state),
    aguardando: state.empresa.aguardando,
    filtro: state.empresa.filtro,
    lista: state.empresa.lista,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            initForm,
            salvar,
            excluir,
            getLista,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(Empresa);
